import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Dna as DnaIcon, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { LEVEL_COLORS } from "@/lib/organs";
import { SectionTitle, DemoBanner } from "@/components/Shared";

const WORKFLOWS = [
  { id: "wf1", label: "Classificazione automatica fornitori ricorrenti", on: true },
  { id: "wf2", label: "Rilevamento duplicati su ogni documento", on: true },
  { id: "wf3", label: "Aggiornamento liquidità serale da POS e banca", on: true },
  { id: "wf4", label: "Promemoria scadenze contrattuali (30 giorni)", on: true },
  { id: "wf5", label: "Pagamenti assistiti da DAD (richiede autorizzazione bancaria)", on: false },
  { id: "wf6", label: "Invio automatico giustificativi al fiduciario", on: false },
];

export default function Dna() {
  const [organ, setOrgan] = useState(null);
  const [toggles, setToggles] = useState(Object.fromEntries(WORKFLOWS.map((w) => [w.id, w.on])));

  useEffect(() => {
    api.get("/organs/dna").then((r) => setOrgan(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4" data-testid="dna-page">
      <Link to="/" className="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-cyan-300 mb-4"><ChevronLeft size={14} /> Organismo</Link>
      <div className="flex items-start justify-between gap-3 mb-5 fade-up">
        <div>
          <p className="text-xs tracking-[0.25em] text-gray-500 flex items-center gap-2"><DnaIcon size={13} /> DNA AZIENDALE</p>
          <h1 className="font-display text-3xl font-bold mt-1">Regole & Configurazione</h1>
          <p className="text-sm text-gray-500 mt-1">Il modo specifico in cui questa azienda opera. DAD impara, ma non accetta mai alla cieca.</p>
        </div>
        <DemoBanner />
      </div>

      <div className="glass rounded-3xl p-5 mb-5 fade-up" data-testid="dna-learning">
        <SectionTitle>Come DAD impara</SectionTitle>
        <div className="flex items-start gap-3 text-sm text-gray-300 leading-relaxed">
          <Sparkles size={16} className="text-cyan-300 shrink-0 mt-0.5" />
          <p>
            Dopo almeno <strong className="text-cyan-200">3 conferme coerenti</strong> per lo stesso fornitore, DAD propone
            la classificazione precedente con maggiore confidenza. Ogni nuovo documento viene comunque letto e verificato:
            se differisce dallo storico, <strong className="text-cyan-200">il documento attuale ha sempre priorità</strong>.
          </p>
        </div>
      </div>

      {organ && (
        <div className="space-y-4 mb-5">
          {organ.sections.map((s) => (
            <div key={s.title} className="glass rounded-3xl p-5">
              <SectionTitle>{s.title}</SectionTitle>
              <div className="space-y-1">
                {s.items.map((it, i) => (
                  <div key={i} className="flex items-center justify-between gap-3 rounded-2xl px-3 py-2.5"
                    style={it.level ? { borderLeft: `2px solid ${LEVEL_COLORS[it.level]}` } : {}}>
                    <span className="text-sm text-gray-200">{it.label}</span>
                    {it.value && <span className="text-sm text-gray-400 shrink-0">{it.value}</span>}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="glass rounded-3xl p-5" data-testid="dna-workflows">
        <SectionTitle>Workflow & automazioni autorizzate</SectionTitle>
        <div className="space-y-1">
          {WORKFLOWS.map((w) => (
            <div key={w.id} className="flex items-center justify-between gap-3 rounded-2xl px-3 py-3">
              <span className="text-sm text-gray-200">{w.label}</span>
              <button
                data-testid={`dna-toggle-${w.id}`}
                onClick={() => setToggles((t) => ({ ...t, [w.id]: !t[w.id] }))}
                className={`w-11 h-6 rounded-full relative transition-colors shrink-0 ${toggles[w.id] ? "bg-cyan-400/80" : "bg-white/10"}`}
                role="switch" aria-checked={toggles[w.id]}>
                <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white transition-all ${toggles[w.id] ? "left-[22px]" : "left-0.5"}`} />
              </button>
            </div>
          ))}
        </div>
        <p className="text-[11px] text-gray-600 mt-3 px-3">Le automazioni che muovono denaro richiedono sempre la tua autorizzazione esplicita.</p>
      </div>
    </div>
  );
}
